"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M9.8 3.613L10.95 2.464L9.536 1.05L8.387 2.2C7.96097 1.92928 7.49192 1.73314 7 1.62V0H5V1.62C4.50808 1.73314 4.03903 1.92928 3.613 2.2L2.464 1.05L1.05 2.464L2.2 3.613C1.92928 4.03903 1.73314 4.50808 1.62 5H0V7H1.62C1.73314 7.49192 1.92928 7.96097 2.2 8.387L1.05 9.536L2.464 10.95L3.613 9.8C4.03903 10.0707 4.50808 10.2669 5 10.38V12H7V10.38C7.49192 10.2669 7.96097 10.0707 8.387 9.8L9.536 10.95L10.95 9.536L9.8 8.387C10.0707 7.96097 10.2669 7.49192 10.38 7H12V5H10.38C10.2669 4.50808 10.0707 4.03903 9.8 3.613ZM6 8C5.60444 8 5.21776 7.8827 4.88886 7.66294C4.55996 7.44318 4.30362 7.13082 4.15224 6.76537C4.00087 6.39991 3.96126 5.99778 4.03843 5.60982C4.1156 5.22186 4.30608 4.86549 4.58579 4.58579C4.86549 4.30608 5.22186 4.1156 5.60982 4.03843C5.99778 3.96126 6.39991 4.00087 6.76537 4.15224C7.13082 4.30362 7.44318 4.55996 7.66294 4.88886C7.8827 5.21776 8 5.60444 8 6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;